
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const modulesFiles = require.context('./modules',true,/\.js$/)
//把modeles中的文件都拿出来
const modules= modulesFiles.keys().reduce((modules,modulePath) => {
  // set './app.js' => 'app'
 const moduleName =modulePath.replace(/^\.\/(.*)\.\w+$/,'$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
},{})

const store =() => new Vuex.Store({ 
  modules
})

export default store






// const cookieparser = process.server ? require("cookieparser") : undefined;
// const Cookie = process.client ? require("js-cookie") : undefined;

// export const state = () => {
//   return {
//     user: null,
//   };
// };
// export const mutations = {
//   setUser(state, user) {
//     state.user = user;
//   },
// };
// export const actions = {
//   nuxtServerInit({ commit }, { req }) {
//     let user = null;
//     if (req.headers.cookie) {
//       const parsed = cookieparser.parse(req.headers.cookie);
//       try {
//         user = JSON.parse(parsed.user);
//       } catch (err) {
//         // No valid cookie found
//       }
//     }
//     commit("setUser", user);
//   },
//   loginAction({ commit }, user) {
//     commit("setUser", user);
//     Cookie.set("user", user);
//   },
//   quitAction({ commit }) {
//     commit("setUser", null);
//     Cookie.set("user", null);
//   },
// };



// WEBPACK FOOTER //
// ./src/store/index.js